import apiCall from "@/data/axios";

interface GetHanwhaSingleCameraParams {
  UniqueId: string;
  DeviceId: string;
}

const getHanwhaSingleCameraAsync = async (body: GetHanwhaSingleCameraParams) => {
  try {
    console.log(body);

    const response = await apiCall("POST", `/hanwha/camera/single`, body);
    console.log(response.data);
    return response.data;
  } catch (error: any) {
    console.error("getHanwhaSingleCameraAsync Error:", error);
    return {
      message: error.message || "An unexpected error occurred."
    };
  }
};

export default getHanwhaSingleCameraAsync;
export type { GetHanwhaSingleCameraParams };
